function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgIconPlay = function SvgIconPlay(props) {
  return h("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80"
  }, props), h("defs", null, h("filter", {
    id: "a",
    width: 80,
    height: 80,
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, h("feOffset", {
    dy: 8
  }), h("feGaussianBlur", {
    result: "blur",
    stdDeviation: 5
  }), h("feFlood", {
    floodOpacity: 0.502
  }), h("feComposite", {
    in2: "blur",
    operator: "in"
  }), h("feComposite", {
    in: "SourceGraphic"
  }))), h("g", {
    filter: "url(#a)"
  }, h("path", {
    fill: "#fff",
    d: "M40 7a25 25 0 1 0 25 25A25 25 0 0 0 40 7m11.663 27.419L33.921 44.6a2.424 2.424 0 0 1-3.6-2.117V21.516a2.425 2.425 0 0 1 3.6-2.117l17.742 10.786a2.427 2.427 0 0 1 0 4.234",
    "data-name": "icon-Play"
  })));
};
export default SvgIconPlay;